import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../../components/dialog/confirm-dialog/confirm-dialog.component';
import { ComponentCanDeactivate } from './can-deactivate.interface';

export const CanDeactivateGuard: CanDeactivateFn<ComponentCanDeactivate> = async (component) => {
  const dialog = inject(MatDialog);

  // Vérifie si canDeactivate est défini et est une fonction
  if (component && typeof component.canDeactivate === 'function') {
    if (component.canDeactivate()) {
      return true;
    }
  } else {
    return true;
  }

  const userConfirmed = await firstValueFrom(
    dialog.open(ConfirmDialogComponent, {
      data: {
        title: 'WARNING',
        text: 'UNSAVED_CHANGES'
      }
    }).afterClosed()
  );

  return userConfirmed === true;
};
